namespace advisorop.components.investor {

    enum DGColumnIndex {
        HouseholdId = 0,
        GroupId,
        AccountCategory,
        AccountId,
        ModelDescription,
        AccountNumber,
        ManagerAndProduct,
        OpenDate,
        UsdMarketValue,
        SleevePercentageOfAG,
        SleevePercentageOfHH,
        GroupType
    };

    export class InvAccountSummaryGridController {
        accounts: Array<any>; //data for grid and pivot
        insuranceAccounts = [];
        haveInsuranceAccounts: boolean = false;
        annuityAccounts = [];
        haveAnnuityAccounts: boolean = false;
        householdId: number;
        public investor: domains.IInvestor;
        showClosedInactive: boolean = false;
        hideSleeves: boolean = true;
        onItemSelected: any;
        onReady: any;
        rootLevel: string;
        dg: DevExpress.ui.dxDataGridOptions;
        dgInsuranceAccounts: DevExpress.ui.dxDataGridOptions;
        dgAnnuityAccounts: DevExpress.ui.dxDataGridOptions;
        accountGroupType: any;
        selrow: any;
        clel: JQuery;
        selASRow: number = -1;

        sortByField: string = "level3Caption";

        ppHHReport: string = "0";

        dontExpandRows = [];

        static $inject = ["householdApi", `acgHelper`]
        constructor(
            private hhApi: services.HouseholdApi,
            private acgs: services.AcgHelper
        ) {

            this.dg = {
                //export: {
                //    enabled: true,
                //    fileName: "Accounts"
                //},
                bindingOptions: {
                    dataSource: "vm.accounts"
                },
                //height: 200,
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                paging: {
                    //pageSize: 5,
                    enabled: false
                },
                rowAlternationEnabled: false,
                showBorders: false,
                showColumnLines: false,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                keyExpr: ['householdId', 'groupId', 'accountId', 'boModelId'],
                selection: {
                    mode: "single"
                },
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                groupPanel: {
                    visible: false
                },
                onContextMenuPreparing: (e: any) => {
                    e.items = [];
                    //if (e.row.rowType == "header") {
                    //    return;
                    //}
                    //var data = this.extractData(e.row);

                    //let level = this.getLevel(e.row.groupIndex);

                    //if (data.accountType != domains.InvestmentType.OUTSIDE_INVESTMENT
                    //    && ( level == "R" || level == "A" || level == "S" )) {
                    //    e.items.push({ text: "Holdings", onItemClick: () => this.openPPReport("Holdings", e.row, level) });
                    //    e.items.push({ text: "Asset Allocation", onItemClick: () => this.openPPReport("AssetAllocation", e.row, level) });
                    //    e.items.push({ text: "Transactions", onItemClick: () => this.openPPReport("Transactions", e.row, level) });
                    //    e.items.push({ text: "Performance", onItemClick: () => this.openPPReport("Performance", e.row, level) });
                    //    e.items.push({ text: "Documents", onItemClick: () => this.openPPReport("Documents%252FStatements", e.row, level) });
                    //};

                    // NEVER FOR CLIENT:
                    //if (level == "R" || level == "A") {
                    //    e.items.push({ text: "Rename", onItemClick: () => this.rename(e.row, level, this.accounts) });
                    //}

                    // DISABLE ACCOUNT SUMMARY FOR INVESTOR LOGIN UNTIL
                    // WE CAN IMPLEMENT THIS
                    //if (level == "A") {
                    //    e.items.push({
                    //        text: "Account Summary", onItemClick: () => {
                    //            // location.href = `/investor/accountsummary/${data.accountId}`;
                    //            alert(`This option is not available yet!`);
                    //        }
                    //    });
                    //}

                    // DISABLE ALL RIGHT MOUSE ACTIONS FOR CLIENT CURRENTLY...

                    // RTG/ADG dashboard
                    //if (this.rootLevel != "R" && data.groupType == 1) {
                    //    e.items.push({
                    //        text: "View Performance", onItemClick: () => {
                    //            location.href = `/investor/rtgdashboard/${data.groupId}`;
                    //        }
                    //    });
                    //}
                    //else if (this.rootLevel != "R" && data.groupType == 2) {
                    //    // var hasManualAccounts = this.accounts.filter((v) => { return v.groupId == data.groupId && v.advisoryFirmMgtRole > 0 }).length > 0;
                    //    // if (!hasManualAccounts) {
                    //    e.items.push({
                    //        text: "View Performance", onItemClick: () => {
                    //            location.href = `/investor/rtgdashboard/${data.groupId}`;
                    //        }
                    //    });
                    //    // }
                    //}

                    // NEVER FOR CLIENT:                 
                    // Modify account RTG
                    //if (this.rootLevel == "R" && data.groupType == 1) {
                    //    e.items.push({ text: "Modify RTG", onItemClick: () => location.href = `/advisor/assignaccountrtg/${data.accountId}`});
                    //}
                },
                onCellPrepared: (e: any) => {
                    // DEMO - SIMULATION OF RIGHT MOUSE CLICK ...
                    //e.cellElement.find(".dx-datagrid-text-content").on("dxclick", function (event) {
                    //    var newEvent = $.extend({}, event, { type: "dxcontextmenu" });
                    //    event.stopPropagation();
                    //    $(this).trigger(newEvent);
                    //});

                    if (e.column.command === "expand" && e.row) {

                        const dontExpand = ((e.data && e.data.collapsedItems && e.data.collapsedItems.length <= 1) || this.hideSleeves == true);

                        // commenting this out to allow users to expand/contract the account category groupings
                        //if (this.rootLevel === "R" && e.row.groupIndex === 1) {
                        //    e.cellElement.html("");
                        //} else if (this.rootLevel !== "R" && e.row.groupIndex === 2) {
                        //    e.cellElement.html("");
                        //} else
                        if (this.rootLevel === "R" && e.row.groupIndex === 2) {
                            // console.log("onCellPrepared RTG: ", e);
                            const ind = this.dontExpandRows.indexOf(e.key[2]);
                            if (dontExpand) {
                                e.cellElement.html("");
                                if (ind < 0) this.dontExpandRows.push(e.key[2]);
                            } else if (!dontExpand && ind >= 0) {
                                this.dontExpandRows.splice(ind, 1);
                            }
                        } else if (this.rootLevel !== "R" && e.row.groupIndex === 3) {
                            const ind = this.dontExpandRows.indexOf(e.key[3]);
                            // console.log("onCellPrepared HH: ", e, ind, dontExpand);
                            if (dontExpand) {
                                e.cellElement.html("");
                                if (ind < 0) this.dontExpandRows.push(e.key[3]);
                            } else if (!dontExpand && ind >= 0) {
                                this.dontExpandRows.splice(ind, 1);
                            }
                        }
                    }

                    if (e.rowType === "group" && e.summaryItems.length === 1) {
                        if (
                            // Do not show managerAndProduct, accountNumber or openDate values above the account level
                            (this.rootLevel !== "R" && e.row.groupIndex < 3 && (e.columnIndex === DGColumnIndex.AccountNumber || e.columnIndex === DGColumnIndex.ManagerAndProduct || e.columnIndex === DGColumnIndex.OpenDate))

                            || (this.rootLevel === "R" && e.row.groupIndex < 2 && (e.columnIndex === DGColumnIndex.AccountNumber - 1 || e.columnIndex === DGColumnIndex.ManagerAndProduct - 1 || e.columnIndex === DGColumnIndex.OpenDate - 1))

                            // Do not show % of Risk Group grand total at topmost HH level
                            || (this.rootLevel !== "R" && e.row.groupIndex === 0 && (e.columnIndex === DGColumnIndex.SleevePercentageOfAG))

                            // Do not show any HH level totals in the ADG dashboard
                            || (this.rootLevel !== "R" && e.row.groupIndex === 0 && this.accountGroupType == 2 && (e.columnIndex === DGColumnIndex.SleevePercentageOfHH || e.columnIndex === DGColumnIndex.UsdMarketValue))

                        )
                            e.cellElement.text("");
                    }
                    else if (e.rowType === "data") {
                        // Do not show managerAndProduct, accountNumber or openDate values at the sleeve level
                        if ((this.rootLevel !== "R" && (e.columnIndex === DGColumnIndex.AccountNumber || e.columnIndex === DGColumnIndex.ManagerAndProduct || e.columnIndex === DGColumnIndex.OpenDate))
                            || (this.rootLevel == "R" && (e.columnIndex === DGColumnIndex.AccountNumber - 1 || e.columnIndex === DGColumnIndex.ManagerAndProduct - 1 || e.columnIndex === DGColumnIndex.OpenDate - 1))) {
                            e.cellElement.text("");
                        }
                        if (this.rootLevel !== "R") {
                            if (e.columnIndex == DGColumnIndex.ModelDescription) {
                                e.cellElement.addClass("grL4ColPad");
                            }
                            if (e.columnIndex >= DGColumnIndex.ModelDescription) {
                                e.cellElement.addClass("grL4Col");
                            }
                        } else {
                            if (e.columnIndex == DGColumnIndex.ModelDescription - 1) {
                                e.cellElement.addClass("grL4ColPad");
                            }
                            if (e.columnIndex >= (DGColumnIndex.ModelDescription - 1)) {
                                e.cellElement.addClass("grL4Col");
                            }
                        }
                    }
                },
                grouping: {
                    autoExpandAll: false,
                    allowCollapsing: true,
                    // expandMode: "rowClick"
                },
                columns: [
                    {
                        dataField: "householdId",
                        caption: "Household",
                        groupIndex: 0,
                        autoExpandGroup: true,
                        // showWhenGrouped: true,
                        //visible: !(this.rootLevel == "R"),
                        groupCellTemplate: (groupCell, info) => {
                            // console.log(groupCell);
                            // console.log(info);
                            var item = this.extractData(info);
                            $("<span>").html(item.householdName).appendTo(groupCell);

                            this.clel = $(groupCell).next("td");
                            let row = $(groupCell).parent("tr");
                            //let row = $(groupCell).context.parentElement; // .addClass("grL1");

                            if (item.advisoryFirmMgtRole == 0 && item.groupType == 3) {
                                $(row).addClass("grL1Err");
                            } else {
                                $(row).addClass("grL1");
                            }
                        }
                    },
                    {
                        dataField: "groupId", caption: "Group",
                        sortIndex: 0,
                        sortOrder: "asc",
                        calculateGroupValue: (rowData) => {  // used for sorting
                            return rowData.groupName;
                        },
                        groupIndex: 1,
                        autoExpandGroup: true,

                        groupCellTemplate: (groupCell, info) => {
                            var item = this.extractData(info);
                            //var grName = item.groupName;
                            //var description = grName;
                            //if (item.groupType == 1 && grName.lastIndexOf("[") >= 0) {
                            //    description = grName.substring(grName.lastIndexOf("[") + 1, grName.lastIndexOf("]"));
                            //    $("<span>").html(description + " (" + item.level2Caption + ")").appendTo(groupCell);
                            //} else {
                            //    $("<span>").html(description).appendTo(groupCell);
                            //}
                            $("<span>").html(item.groupDescription).appendTo(groupCell);

                            // RTG groups
                            if (this.rootLevel !== "R" && item.groupType == 1) {
                                var lnk = $(`<a href="/investor/rtgdashboard/${item.groupId}" class="btn btn-info btn-xs m-l-sm">`).html("View Performance"); //<i class="fa fa-dashboard"> </i>
                                lnk.appendTo(groupCell);
                            }
                            // ADG groups
                            else if (this.rootLevel !== "R" && item.groupType == 2) {
                                var hasManualAccounts = this.accounts.filter((v) => { return v.groupId == item.groupId && v.advisoryFirmMgtRole > 0 }).length > 0;
                                if (!hasManualAccounts) {
                                    var lnk = $(`<a href="/investor/adgdashboard/${item.groupId}" class="btn btn-info btn-xs m-l-sm">`).html("View Performance"); //<i class="fa fa-dashboard"> </i>
                                    lnk.appendTo(groupCell);
                                }
                                else {
                                    var lnk = $(`<button type="button" class="btn btn-info btn-xs m-l-sm" disabled>`).html("View Performance"); //<i class="fa fa-dashboard"> </i>
                                    lnk.appendTo(groupCell);
                                }
                            }

                            let row = $(groupCell).parent("tr");
                            //let row = $(groupCell).context.parentElement; //.addClass("grL1");

                            if (item.advisoryFirmMgtRole == 0 && item.groupType == 3) {
                                $(row).addClass("grL2Err");
                            }
                            else {
                                $(row).addClass("grL2");
                            }
                        }
                    },
                    {
                        dataField: "accountCategory",
                        caption: "AccountCategory",
                        groupIndex: 2,
                        sortIndex: 0,
                        sortOrder: "desc",
                        autoExpandGroup: true,
                        groupCellTemplate: (groupCell, info) => {
                            var item = this.extractData(info);
                            $("<span>").html(item.accountCategory).appendTo(groupCell);
                            let row = $(groupCell).parent("tr");
                            //let row = $(groupCell).context.parentElement;
                            $(row).addClass("grL2");
                        }
                    },
                    {
                        dataField: "accountId",
                        cssClass: "advisorop-gridcol",
                        caption: "Account",
                        groupIndex: 3,
                        calculateDisplayValue: (rowDatas) => {
                            let rowData = rowDatas;

                            if (rowDatas.items) {
                                rowData = rowDatas.items[0];
                            }

                            let keySortByField = this.acgs.calcSortableFieldValue(rowData, this.sortByField, this.accounts);

                            const sortExpr = `${keySortByField}-${rowData.level3Caption}-${rowData.accountId}`;

                            return sortExpr.trim();
                        },
                        groupCellTemplate: (groupCell, info) => {
                            //console.log(info);
                            var item = this.extractData(info);
                            $("<span>").html(`${item.level3Caption}`).appendTo(groupCell);
                            //if (this.rootLevel == "R" && item.groupType == 1) {
                            //    let lnk = $(`<a href="/advisor/assignaccountrtg/${item.accountId}" class="btn btn-default btn-xs m-l-sm">`).html("Modify RTG"); //<i class="fa fa-dashboard"> </i>
                            //    lnk.appendTo(groupCell);
                            //}
                            let row = $(groupCell).parent("tr");
                            //let row = $(groupCell).context.parentElement; //.addClass("grL1");
                            if (item.advisoryFirmMgtRole == 0 && item.groupType == 3) {
                                $(row).addClass("grL3Err");
                            }
                            else {
                                $(row).addClass("grL3");
                            }
                        }
                    },
                    { dataField: "modelDescription", caption: "Account/Model", cssClass: "advisorop-gridcol", width: 200, allowReordering: false },
                    { dataField: "accountNumber", caption: "Account #", cssClass: "advisorop-gridcol", width: 100, allowReordering: false },
                    { dataField: "managerAndProduct", caption: "Product", cssClass: "advisorop-gridcol", width: 350, allowReordering: false },
                    { dataField: "openDate", caption: "Start Date", headerCellTemplate: (h, info) => { $(h).attr("title", "Sourced from Orion").append($("<span>").text(info.column.caption || "")); }, cssClass: "advisorop-gridcol", width: 70, allowReordering: false, allowSorting: false },
                    { dataField: "usdMarketValue", caption: "Market Value", cssClass: "advisorop-gridcol", format: "currency", allowReordering: false },
                    { dataField: "sleevePercentageOfAG", caption: "% of Group", cssClass: "advisorop-gridcol", dataType: "number", format: { type: "percent", precision: 2 }, allowReordering: false },
                    { dataField: "sleevePercentageOfHH", caption: "% of Household", cssClass: "advisorop-gridcol", dataType: "number", format: { type: "percent", precision: 2 }, allowReordering: false },
                    { dataField: "groupType", visible: false }
                ],
                sortByGroupSummaryInfo: [
                    { summaryItem: "groupType", sortOrder: "asc" }
                ],
                summary: {
                    groupItems: [
                        {
                            column: "usdMarketValue",
                            alignByColumn: true,
                            summaryType: "sum",
                            displayFormat: "{0}",
                            valueFormat: "currency",
                            //customizeText: function (obj) {
                            //    console.log(obj);                                
                            //    return $("<div>").html(obj.valueText).addClass("pull-right").text();
                            //}          
                            //showInGroupFooter: true,                            
                        },
                        {
                            column: "managerAndProduct",
                            alignByColumn: true,
                            summaryType: "min",
                            displayFormat: "{0}",
                        },
                        {
                            column: "accountNumber",
                            alignByColumn: true,
                            summaryType: "min",
                            displayFormat: "{0}",
                        },
                        {
                            column: "openDate",
                            alignByColumn: true,
                            summaryType: "min",
                            displayFormat: "{0}",
                        },
                        {
                            column: "sleevePercentageOfAG",
                            alignByColumn: true,
                            summaryType: "custom",
                            displayFormat: "{0}",
                            valueFormat: {
                                type: "percent",
                                precision: 2
                            },
                        },
                        {
                            column: "sleevePercentageOfHH",
                            alignByColumn: true,
                            summaryType: "custom",
                            displayFormat: "{0}",
                            valueFormat: {
                                type: "percent",
                                precision: 2
                            },
                        },
                        {
                            column: "groupType",
                            showInColumn: "false",
                            summaryType: "max"
                        }
                    ],
                    calculateCustomSummary: (e) => {
                        switch (e.summaryProcess) {
                            case "start":
                                e.totalValue = 0;
                                break;
                            case "calculate":
                                e.totalValue += e.value;
                                break;
                            case "finalize":
                                var roundedValue = e.totalValue * 10000;
                                var roundedValue2 = Math.round(roundedValue);
                                e.totalValue = roundedValue2 / 10000;
                        }
                    }
                },
                onRowPrepared: (e: any) => {
                    if (e.rowIndex == this.selASRow) {
                        var r = $(e.rowElement);
                        r.addClass("acsrow");
                    }
                },
                onCellClick: (e) => {
                    //console.log("Cell clicked: ", e.key, e.column);
                    if (e.rowType === "header") {

                        //disable sorting if column is not sortable
                        if (!e.column.allowSorting) {
                            return;
                        }


                        const ind = 2; //  this.rootLevel == "R" ? 1 : 2;
                        this.sortByField = this.acgs.mapSummaryGridSortColumn(e.column.dataField);

                        const sortOrder = e.component.columnOption(ind/*e.columnIndex*/, "sortOrder") === "desc" ? "asc" : "desc";

                        //console.log(`Sort column ${e.component.columnOption(ind, "dataField")} ${sortOrder} over ${e.columnIndex}`);

                        e.component.columnOption(ind, "sortOrder", sortOrder);
                        e.component.columnOption(e.columnIndex, "sortOrder", sortOrder);
                    }
                },
                onRowExpanding: (e: any) => {
                    //                    if (this.hideSleeves == true) {
                    //                        e.cancel = true;
                    //                    } else if (this.rootLevel === "R" && e.key.length === 2) {
                    if (this.rootLevel === "R" && (e.key.length === 3)) {
                        e.cancel = this.dontExpandRows.indexOf(e.key[2]) >= 0;
                    } else if (this.rootLevel !== "R" && (e.key.length === 4)) {
                        e.cancel = this.dontExpandRows.indexOf(e.key[3]) >= 0;
                    }
                },
                // commenting this out to allow the users to expand/collapse account category groupings
                //onRowCollapsing: (e: any) => {
                //    //console.log("THE KEY IS", e.key);
                //    e.cancel = (this.rootLevel === "R" && e.key.length === 2) || (this.rootLevel !== "R" && e.key.length === 3);
                //},
                onRowClick: (e) => {

                    var maxDepth = 5;
                    var item = e;
                    var groupIndex = e.groupIndex;

                    if (this.selASRow == e.rowIndex)
                        return;

                    e.component.deselectRows(e.component.getKeyByRowIndex(this.selASRow))

                    this.selASRow = e.rowIndex;

                    var r = $(e.rowElement);
                    $("#dgHouseholds tr.acsrow").each((ind, elm) => {
                        $(elm).removeClass("acsrow");
                    });
                    r.addClass("acsrow");

                    let data = this.extractData(e);

                    let level = this.getLevel(groupIndex)

                    if (level != "AG") {
                        let additionalData = this.calculateAdditionalData(level, data);

                        //if (data.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT && (level == "A" || level == "S")) {
                        // outside  
                        //    this.onItemSelected({ item: data, level: "O" + level, additionalData: additionalData });
                        //} else {
                        this.onItemSelected({ item: data, level: level, additionalData: additionalData });
                        //}
                    }
                },
                onContentReady: (e) => {

                    if (this.rootLevel == "R") {
                        e.component.columnOption("householdId", "visible", false);
                        e.component.columnOption("householdId", "groupIndex", undefined);
                        e.component.columnOption("groupId", "groupIndex", 0);
                        e.component.columnOption("accountCategory", "groupIndex", 1);
                        e.component.columnOption("accountId", "groupIndex", 2);
                    }

                    // Deselect all rows on initial content ready
                    $("#dgHouseholds tr.acsrow").each((ind, elm) => {
                        $(elm).removeClass("acsrow");
                    });

                    //in case of RTG we need to show Summary on the top level node
                    if (this.clel && this.accountGroupType != 1)
                        this.clel.text("");

                    if (this.accountGroupType == 2) {
                        e.component.columnOption("sleevePercentageOfHH", "visible", false);
                    } else {
                        e.component.columnOption("sleevePercentageOfHH", "visible", true);
                    }
                }
            };

            // annuity accounts 
            this.dgAnnuityAccounts = {
                //export: {
                //    enabled: true,
                //    fileName: "AnnuityAccounts"
                //},
                bindingOptions: {
                    dataSource: "vm.annuityAccounts"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                paging: {
                    enabled: false
                },
                rowAlternationEnabled: true,
                showBorders: false,
                showRowLines: false,
                showColumnLines: false,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                selection: {
                    mode: "single"
                },
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                groupPanel: {
                    visible: false
                },
                onContextMenuPreparing: (e: any) => {
                    //e.items = [];
                    //if (e.row.rowType != "data") {
                    //    return;
                    //}
                    //console.log("E IS:", e);
                    //e.items.push({ text: "Rename Account", onItemClick: () => this.rename(e.row, "A", this.annuityAccounts) });
                    //e.items.push({ text: "Account Summary", onItemClick: () => location.href = `/advisor/accountsummary/${e.row.data.accountId}` });
                },
                grouping: {
                    autoExpandAll: false,
                    allowCollapsing: true
                },
                columns: [
                    {
                        dataField: "groupName",
                        caption: "Group",
                        groupIndex: 0,
                        autoExpandGroup: true,
                        visible: true,
                        groupCellTemplate: (groupCell, info) => {
                            var item = this.extractData(info);
                            $("<span>").html(`${item.groupName}`).appendTo(groupCell);
                            let row = $(groupCell).parent("tr");
                            //let row = $(groupCell).context.parentElement;
                            $(row).addClass("grL1");
                        }
                    },
                    // move to template if you want to use this
                    //<div data - options="dxTemplate: {name: 'colAccount'}" >
                    //{{ item.data.accountName }} { { item.data.policyNumber } }
                    //<!--< a class="btn btn-default btn-xs" tooltip - placement="right" ng - click="Assign HH" >& nbsp; <i class="fa fa-dashboard" > </i></a > -->
                    //</div>
                    { dataField: "accountName", caption: "Account Name" },
                    //{ dataField: "policy", caption: "Policy Type" },
                    //{ dataField: "policyCompany", caption: "Company" },
                    //{ dataField: "productDescription", caption: "Product" },
                    { dataField: "accountNumber", caption: "Policy Number", width: 100, sortIndex: 0, sortOrder: "asc" },
                    { dataField: "managerProduct", caption: "Product" },
                    { dataField: "issueDate", caption: "Issue Date", dataType: "date" },
                    { dataField: "outOfSurrenderDate", caption: "Out of Surrender Date", dataType: "date" },
                    { dataField: "initialPremium", caption: "Initial Premium", format: "currency", width: 84 },
                    { dataField: "incomeValue", caption: "Income Value", format: "currency", width: 84 },
                    { dataField: "cashValue", caption: "Cash Value", format: "currency", width: 84 }
                ],
                summary: {
                    groupItems: [
                        {
                            column: "incomeValue",
                            alignByColumn: true,
                            summaryType: "sum",
                            displayFormat: "{0}",
                            valueFormat: "currency",
                        },
                        {
                            column: "cashValue",
                            alignByColumn: true,
                            summaryType: "sum",
                            displayFormat: "{0}",
                            valueFormat: "currency",
                        },
                    ]
                }
            };

            // insurance accounts 
            this.dgInsuranceAccounts = {
                //export: {
                //    enabled: true,
                //    fileName: "InsuranceAccounts"
                //},
                bindingOptions: {
                    dataSource: "vm.insuranceAccounts"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                paging: {
                    enabled: false
                },
                rowAlternationEnabled: true,
                showBorders: false,
                showRowLines: false,
                showColumnLines: false,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                selection: {
                    mode: "single"
                },
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                groupPanel: {
                    visible: false
                },
                onContextMenuPreparing: (e: any) => {
                    //e.items = [];
                    //if (e.row.rowType != "data") {
                    //    return;
                    //}
                    //let level = "A" // this.getLevel(e.row.groupIndex);
                    //if (level == "R" || level == "A") {
                    //    e.items.push({ text: "Rename", onItemClick: () => this.rename(e.row, level, this.insuranceAccounts) });
                    //}
                },
                grouping: {
                    autoExpandAll: false,
                    allowCollapsing: true
                },
                columns: [
                    {
                        dataField: "groupName",
                        caption: "Group",
                        groupIndex: 0,
                        autoExpandGroup: true,
                        visible: true,
                        groupCellTemplate: (groupCell, info) => {
                            var item = this.extractData(info);
                            $("<span>").html(`${item.groupName}`).appendTo(groupCell);
                            let row = $(groupCell).parent("tr");
                            //let row = $(groupCell).context.parentElement;
                            $(row).addClass("grL1");
                        }
                    },
                    //{ dataField: "policy", caption: "Policy" },
                    //{ dataField: "accountId", caption: "Account", cellTemplate: "colAccount" },
                    { dataField: "accountName", caption: "Account Name" },
                    //{ dataField: "policy", caption: "Policy Type" },
                    //{ dataField: "policyCompany", caption: "Company" },
                    //{ dataField: "productDescription", caption: "Product" },
                    { dataField: "accountNumber", caption: "Policy Number", width: 100 },
                    { dataField: "managerProduct", caption: "Product" },
                    { dataField: "benefit", caption: "Benefit", format: "currency" },
                    { dataField: "cashValue", caption: "Cash Value", format: "currency" }
                ],
                summary: {
                    groupItems: [
                        {
                            column: "cashValue",
                            alignByColumn: true,
                            summaryType: "sum",
                            displayFormat: "{0}",
                            valueFormat: "currency",
                        },
                        {
                            column: "benefit",
                            alignByColumn: true,
                            summaryType: "sum",
                            displayFormat: "{0}",
                            valueFormat: "currency",
                        }
                    ]
                }
            };

        } // constructor

        // helper methods
        formatZeroDpCurrency(num: number): string {
            var ret = '$' + num.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
            return ret;
        }

        calculateAdditionalData = (level: string, data: any): string => {
            if (level == "H") {
                return data.householdName + " - Household Level";
            }
            else if (level == "R") {
                return data.groupDescription + " - Account Group";
            }
            else if (level == "A") {
                var acctValue = this.accounts.filter(item => item.accountId === data.accountId && item.groupId === data.groupId)
                    .reduce((acctValue, current) => acctValue + current.usdMarketValue, 0);

                return data.level3Caption + ` (${data.accountNumber} ${this.formatZeroDpCurrency(acctValue)})`;
            }
            // Sleeve
            return data.level3Caption + ` (${data.accountNumber}) - ` + data.modelDescription + ` (${this.formatZeroDpCurrency(data.usdMarketValue)})`;
        }

        extractData(e): any {
            var maxDepth = 5;
            var item = e;

            for (var d = 0; d < maxDepth; d++) {
                if (item.rowType === "group" && d == 0) {
                    item = item.data.items ? item.data.items[0] : item.data.collapsedItems[0];
                }
                else if ((item.items || item.collapsedItems) && d > 0) {
                    item = item.items ? item.items[0] : item.collapsedItems[0];
                }
                else if (!(item.items || item.collapsedItems) && d > 0) {
                    return item;
                }
                else if (item.rowType === "data") {
                    return item.data;
                }
            }
        };

        getLevel(groupIndex: number): string {
            if (groupIndex != undefined) {
                if (this.rootLevel === "R")
                    groupIndex = groupIndex + 1;

                if (groupIndex == 0) return "H";
                else if (groupIndex == 1) return "R";
                else if (groupIndex == 2) return "AG";
                else if (groupIndex == 3) return "A";
            }
            return "S";
        }

        //ppHHReportSelected(item): void {
        //    // console.log("Selected PP report: ", item);
        //    this.ppHHReport = "0";
        //};

        //openPPReport(report: string, e: any, level: string): void {
        //    let pplevel = "";
        //    let ppclientid = "0";
        //    let data = this.extractData(e);
        //    if (level == "H") {
        //        return;
        //    }
        //    else if (level == "R") {
        //        pplevel = "HH";
        //        ppclientid = data.groupId;
        //    }
        //    else if (level == "A") {
        //        pplevel = "CG";
        //        ppclientid = data.accountId;
        //    }
        //    else if (level == "S") {
        //        pplevel = "AC";
        //        ppclientid = `${data.accountId}_${data.modelID}`;
        //    }

        //    let url = `/samlidp/openppreport/${ppclientid}/${pplevel}/${report}`;
        //    if (!this.ppWnds[ppclientid] || (<Window>this.ppWnds[ppclientid]).closed) {
        //        this.ppWnds[ppclientid] = window.open(url, "_blank");
        //        if (!this.ppWnds[ppclientid]) {
        //            toastr.warning("Your browser blocking popups from this site! Please enable popups for AdvisorOp!");
        //        }
        //    }
        //    else {
        //        this.ppWnds[ppclientid].location.href = url;
        //        this.ppWnds[ppclientid].focus();
        //    }
        //}

        $onInit(): void {
            var component = this;
            this.onReady({ component });
        }

        loadHDAccounts(): void {
            this.hhApi.getAccountGroupsSummary(this.householdId, this.accountGroupType, this.showClosedInactive)
                .then(response => {
                    this.accounts = response.data.gridData;
                    //console.log("RESPONSE DATA", response.data);
                    this.insuranceAccounts = response.data.insuranceAccounts ?? []
                    this.annuityAccounts = response.data.annuityAccounts ?? [];

                }, err => toastr.error("Unexpected error during account loading... ERROR " + err.status + " " + err.data));
        };

        getShowSleeves(): void {
            if (this.investor != undefined) {
                let showSleevesOption = this.investor.loginOptions.filter(o => o.type == domains.LovType.INVESTOR_LOGIN_OPTION_TYPE && o.option == domains.InvestorLoginOption.SHOW_SLEEVES);
                if (showSleevesOption.length > 0) {
                    if (this.hideSleeves != (showSleevesOption[0].value == 0)) {
                        this.hideSleeves = showSleevesOption[0].value == 0;
                        this.onChangedOptionForHideSleeves();
                    }
                }
            }
        }

        onChangedOptionForShowClosedInactive(): void {
            if (this.householdId) {
                this.accounts = null;
                this.loadHDAccounts();
            }
        }

        onChangedOptionForHideSleeves(): void {
            // Collapse any open account levels
            let dg = DevExpress.ui.dxDataGrid.getInstance($('#dgHouseholds')) as DevExpress.ui.dxDataGrid;
            if (this.hideSleeves == true) {
                if (dg) {
                    let vr = dg.getVisibleRows();
                    for (let i = 0; i < vr.length; i++) {
                        var groupIndex = vr[i].groupIndex
                        let level = this.getLevel(groupIndex)
                        if (level == "A") {
                            dg.collapseRow(vr[i].key);
                        }
                    }
                }
            }
            dg.refresh();
        }

        $onChanges(evt) {
            for (var key in evt) {
                //                if (key === "householdId" && this.householdId) {
                //                    this.loadHDAccounts();
                //                }
                if (key === "insuranceAccounts") {
                    if (this.insuranceAccounts && this.insuranceAccounts.length > 0)
                        this.haveInsuranceAccounts = true;
                    else
                        this.haveInsuranceAccounts = false;
                } else if (key === "annuityAccounts") {
                    if (this.annuityAccounts && this.annuityAccounts.length > 0)
                        this.haveAnnuityAccounts = true;
                    else
                        this.haveAnnuityAccounts = false;
                } else if (key === "investor") {
                    this.getShowSleeves();
                }
            }
        };

    }



    class InvAccountSummaryGrid implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                accounts: "<",
                insuranceAccounts: "<",
                annuityAccounts: "<",
                householdId: "<",
                accountGroupType: "<",
                investor: "<",
                onItemSelected: "&",
                onReady: "&",
                rootLevel: "@"
            };
            this.controller = InvAccountSummaryGridController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/investor-module/components/inv-account-summary-grid.html";
        }
    }
    angular.module(Constants.APP).component("invAccountSummaryGrid", new InvAccountSummaryGrid());

}